import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as SettingActions from './../actions/settingScreen_actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { validate } from '../validations';
import { ModalDialogCommon } from './modal_dialog_common';
import * as FacilitiesActions from './../actions/facilities_actions';
import * as AdminDashboardActions from './../actions/admin/dashboard_actions';
import * as DashboardActions from './../actions/dashboard_actions';
import * as UserActions from './../actions/user_actions';

let securityQuestion = React.createClass({
    getInitialState() {
        return {
            modelMessage: null,
            isUpdateSecurityQuestionsSuccess: null,
        }
    },
    componentWillReceiveProps(nextProps) {

        if (nextProps.Settings.updateUserSelectedSecurityQuestionsStatus && nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.status == 200) {
            this.setState({ modelMessage: nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.message, isUpdateSecurityQuestionsSuccess: true, })
        }

        if (nextProps.Settings.updateUserSelectedSecurityQuestionsStatus && nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.status != 200) {
            this.setState({ modelMessage: nextProps.Settings.updateUserSelectedSecurityQuestionsStatus.message, isUpdateSecurityQuestionsSuccess: false, })
        }

         if (nextProps.SessionLogoutResponse) {
            if (nextProps.SessionLogoutResponse.status == 200) {
                this.props.Dispatch(UserActions.user_log_out());
                localStorage.clear();
                this.props.router.push('/');
            } else {
                // need to show error msg from server response
            }
        }
    },
    componentWillMount() {

        if (this.props.LogingDetails && this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility) {
            if (this.props.LogingDetails.data.sequrityAnswer.length !== 0) {
                this.props.router.push('/');
                return;
            }
        }
        else if (!this.props.LogingDetails) {
            this.props.router.push('/');
            return false;
        }
          else if (this.props.LogingDetails.data && this.props.LogingDetails.data.sequrityAnswer.length !== 0 ){
            if ( this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility ) {
                this.props.router.push('/dashboard');
                document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
                //this.props.Dispatch(FacilitiesActions.getAllfacilities());
                this.props.Dispatch(FacilitiesActions.getfacilitiesbySearch({
                    "searchChar": '',
                    "page": 1,
                    "size": 9,
                }));
                return false;
            }else{
                this.props.router.push('/select-clinic');
            }
          }
        this.props.Dispatch(SettingActions.getAllSecurityQuestions());
    },
    componentDidMount() {

    },
    email_validate(event) {
        validate.email(event.target.value.trim()) ? event.target.parentElement.className = 'input-b-border' : event.target.parentElement.className = 'input-b-border error-border-bottom';

    },
    sendBack() {
         this.props.Dispatch(UserActions.logout(
            {
                "appType": "WEB",
                "id": this.props.LogingDetails.data.id
            }
        ));
    },

    Submit() {
        // Questions & Answers validations
        let isValidQ1 = validate.noSpaces(this.refs.question1Id);
        let isValidQ1Answer = validate.noSpaces(this.refs.question1Answer);
        isValidQ1 && isValidQ1Answer ? this.refs.question1Answer.parentElement.className = 'input-b-border' : this.refs.question1Answer.parentElement.className = 'input-b-border error-border-bottom';

        let isValidQ2 = validate.noSpaces(this.refs.question2Id);
        let isValidQ2Answer = validate.noSpaces(this.refs.question2Answer);
        isValidQ2 && isValidQ2Answer ? this.refs.question2Answer.parentElement.className = 'input-b-border' : this.refs.question2Answer.parentElement.className = 'input-b-border error-border-bottom';

        let isValidQ3 = validate.noSpaces(this.refs.question3Id);
        let isValidQ3Answer = validate.noSpaces(this.refs.question3Answer);
        isValidQ3 && isValidQ3Answer ? this.refs.question3Answer.parentElement.className = 'input-b-border' : this.refs.question3Answer.parentElement.className = 'input-b-border error-border-bottom';

        // let isValidQ4 = validate.noSpaces(this.refs.question4Id);
        // let isValidQ4Answer = validate.noSpaces(this.refs.question4Answer);
        // isValidQ4 && isValidQ4Answer ? this.refs.question4Answer.parentElement.className = 'input-b-border' : this.refs.question4Answer.parentElement.className = 'input-b-border error-border-bottom';

        // let isValidQ5 = validate.noSpaces(this.refs.question5Id);
        // let isValidQ5Answer = validate.noSpaces(this.refs.question5Answer);
        // isValidQ5 && isValidQ5Answer ? this.refs.question5Answer.parentElement.className = 'input-b-border' : this.refs.question5Answer.parentElement.className = 'input-b-border error-border-bottom';

        let email = '';
        if (this.props.LogingDetails && this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility ) {
            email = this.refs.emailUpdate.value.trim();
            if (validate.email(email)) {
                this.refs.emailUpdate.parentElement.className = 'input-b-border'
            }
            else {
                this.refs.emailUpdate.parentElement.className = 'input-b-border error-border-bottom';
                // this.setState({
                //     modelMessage: 'Please select and answer all the security questions to proceed.',
                // })
                // return;
            }

        }

        // && isValidQ4 && isValidQ4Answer && isValidQ5 && isValidQ5Answer
        if (isValidQ1 && isValidQ1Answer && isValidQ2 && isValidQ2Answer && isValidQ3 && isValidQ3Answer ) {

            if (this.props.LogingDetails && this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility ) {
                if (email.trim().length === 0) {
                    this.setState({
                        modelMessage: 'Please enter necessary fields to proceed.',
                    })
                    return;
                }
                if (!validate.email(email)) {
                    this.setState({
                        modelMessage: 'Please enter valid email address to proceed.',
                    })
                    return;
                }
            }

            // Unique Answer verification
            let hasRepeatedAnswers = null;
            for (let sq = 1; sq <= 3; sq++) {
                for (let i = 1; i <= 3; i++) {
                    if (sq != i) {
                        if (this.refs['question' + sq + 'Answer'].value.trim() === this.refs['question' + i + 'Answer'].value.trim()) {
                            this.refs['question' + sq + 'Answer'].parentElement.className = 'input-b-border error-border-bottom';
                            this.refs['question' + i + 'Answer'].parentElement.className = 'input-b-border error-border-bottom';
                            hasRepeatedAnswers = true;
                        }
                    }
                }
            }
            if (hasRepeatedAnswers) {
                this.setState({ modelMessage: 'Please enter a unique answer to each question.' });
                return;
            }

            var data = {
                "id": this.props.LogingDetails.data.id,
                "uniqueKey": this.props.LogingDetails.data.uniqueKey,
                //"email": email,
                "sequrityAnswer": [
                    {
                        "answer": this.refs.question1Answer.value.trim(),
                        "question": {
                            "id": this.refs.question1Id.value
                        }
                    },
                    {
                        "answer": this.refs.question2Answer.value.trim(),
                        "question": {
                            "id": this.refs.question2Id.value
                        }
                    },
                    {
                        "answer": this.refs.question3Answer.value.trim(),
                        "question": {
                            "id": this.refs.question3Id.value
                        }
                    },
                    // {
                    //     "answer": this.refs.question4Answer.value.trim(),
                    //     "question": {
                    //         "id": this.refs.question4Id.value
                    //     }
                    // },
                    // {
                    //     "answer": this.refs.question5Answer.value.trim(),
                    //     "question": {
                    //         "id": this.refs.question5Id.value
                    //     }
                    // },
                ]
            }

            if (this.props.LogingDetails && this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility ) {
                data.email = email;
            }
            this.props.Dispatch(SettingActions.updateSecrityQuestions(data))
        }
        else {
            this.setState({
                modelMessage: 'Please select and answer all the security questions to proceed.',
            })
        }
    },
    closebox() {
        this.setState({ modelMessage: null });

        // Super Admin Dashboard redirection

        if (this.state.isUpdateSecurityQuestionsSuccess && this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility ) {
            this.props.router.push('/dashboard');
            document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
            //this.props.Dispatch(FacilitiesActions.getAllfacilities());
            this.props.Dispatch(FacilitiesActions.getfacilitiesbySearch({
                "searchChar": '',
                "page": 1,
                "size": 9,
            }));
            return false;
        }else if(this.state.isUpdateSecurityQuestionsSuccess){
            this.props.router.push('/select-clinic');
        }



    },
    navigationHandler() {

    },

    selectionChanged(event) {
        // event.target.value != "" ? event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown' : event.target.parentElement.parentElement.parentElement.className = 'aj-dropdown error-border-bottom';
    },

    remove_error(event) {
        event.target.parentElement.className = 'input-b-border';
    },
    no_empty(event) {
        let value = event.target.value;
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? event.target.parentElement.className = 'input-b-border' : event.target.parentElement.className = 'input-b-border error-border-bottom';
    },

    render() {
        var questions = this.props.Settings.allSecurityQuestions ? this.props.Settings.allSecurityQuestions.data : [],
            q1Questions = [], q2Questions = [], q3Questions = [], q4Questions = [], q5Questions = [];
        _.forEach(questions, function (value, key) {
            if (key < 5) {
                q1Questions.push(questions[key])
            }
            if (key >= 5 && key < 10) {
                q2Questions.push(questions[key])
            }
            if (key >= 10 && key < 15) {
                q3Questions.push(questions[key])
            }
            if (key >= 15 && key < 20) {
                q4Questions.push(questions[key])
            }
            if (key >= 20 && key < 25) {
                q5Questions.push(questions[key])
            }
        });
        return (
            <div className="vertalign-container">

                <div className="vertalign-child">
                    <h1 className="top-logo">MOBI</h1>

                    <div className="admin-login security security-ques"><span onClick={this.sendBack} className="icon-backarrow"></span>
                        <p className="login-head">Let's set up some security questions just in case you get locked out of your account.</p>

                        <div className="btn-group question-select">
                            <div className="dropdown">

                                <div className="select-wrapper">
                                    <div className="question-selection" >
                                        <select ref="question1Id" onChange={this.selectionChanged} data-selectedto='1'>
                                            <option value="" default>Please select</option>
                                            {
                                                _.map(q1Questions, (Data, key) => {
                                                    return (
                                                        <option key={key} value={Data.id}>
                                                            {Data.name}
                                                        </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="input-b-border">
                                    <input className="update-mail" type="text" placeholder="Your security answer" ref="question1Answer" onFocus={this.remove_error} onBlur={this.no_empty} />
                                </div>
                                <div className="select-wrapper">
                                    <div className="question-selection">
                                        <select ref="question2Id" onChange={this.selectionChanged}>
                                            <option value="" default>Please select</option>
                                            {
                                                _.map(q2Questions, (Data, key) => {
                                                    return (
                                                        <option key={key} value={Data.id}>
                                                            {Data.name}
                                                        </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="input-b-border">
                                    <input className="update-mail" type="text" placeholder="Your security answer" ref="question2Answer" onFocus={this.remove_error} onBlur={this.no_empty} />
                                </div>
                                <div className="select-wrapper">
                                    <div className="question-selection">
                                        <select ref="question3Id" onChange={this.selectionChanged}>
                                            <option value="" default>Please select</option>
                                            {
                                                _.map(q3Questions, (Data, key) => {
                                                    return (
                                                        <option key={key} value={Data.id}>
                                                            {Data.name}
                                                        </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="input-b-border">
                                    <input className="update-mail" type="text" placeholder="Your security answer" ref="question3Answer" onFocus={this.remove_error} onBlur={this.no_empty} />
                                </div>
                                {/* <div className="select-wrapper">
                                    <div className="question-selection">
                                        <select ref="question4Id" onChange={this.selectionChanged}>
                                            <option value="" default>Please select</option>
                                            {
                                                _.map(q4Questions, (Data, key) => {
                                                    return (
                                                        <option key={key} value={Data.id}>
                                                            {Data.name}
                                                        </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="input-b-border">
                                    <input className="update-mail" type="text" placeholder="Your security answer" ref="question4Answer" onFocus={this.remove_error} onBlur={this.no_empty} />
                                </div> */}
                                {/* <div className="select-wrapper">
                                    <div className="question-selection">
                                        <select ref="question5Id" onChange={this.selectionChanged}>
                                            <option value="" default>Please select</option>
                                            {
                                                _.map(q5Questions, (Data, key) => {
                                                    return (
                                                        <option key={key} value={Data.id}>
                                                            {Data.name}
                                                        </option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="input-b-border">
                                    <input className="update-mail" type="text" placeholder="Your security answer" ref="question5Answer" onFocus={this.remove_error} onBlur={this.no_empty} />
                                </div> */}
                            </div>
                        </div>

                        {(this.props.LogingDetails && this.props.LogingDetails.data && !this.props.LogingDetails.data.facilities[0].facility ) &&
                            <div className="input-b-border">
                                <input className="update-mail" type="text" placeholder="Please update your email" onBlur={this.email_validate} ref="emailUpdate" />
                            </div>
                        }

                        <div className="default-button-container save">
                            <button className="gray-button" onClick={this.Submit}>SAVE</button>
                        </div>
                    </div>
                </div>

                {this.state.modelMessage && <ModalDialogCommon message={this.state.modelMessage} action={this.closebox} />}
            </div>
        );
    }
});


let mapStateToProps = (state) => {
    return {
        UserDetails : state.User,
        AllSecurityQuestions: state.Setting.allSecurityQuestions,
        LogingDetails: state.User.loginData,
        Settings: state.Setting,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};

let mapDispatchToProps = (dispatch) => ({
    SettingActions: bindActionCreators(SettingActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(securityQuestion));



/** WEBPACK FOOTER **
 ** ./src/components/securityquestion.js
 **/